import { render, staticRenderFns } from "./qj.vue?vue&type=template&id=081665cb&scoped=true&"
import script from "./qj.vue?vue&type=script&lang=js&"
export * from "./qj.vue?vue&type=script&lang=js&"
import style0 from "./qj.vue?vue&type=style&index=0&id=081665cb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081665cb",
  null
  
)

export default component.exports